export const STAGE_URL = '/stage';